import axios from '../plugins/axios'

export default {
    create({ source }){
      return axios.post('/api/v1/cards/create', {
        source: source
      })
    },
    update({ card_token }){
      return axios.post('/api/v1/cards/update', {
        card_token: card_token
      })
    },
    delete({ card_token }){
      return axios.post('/api/v1/cards/destroy', {
        card_token: card_token
      })
    },
}
